export default __webpack_public_path__ + "static/media/box-arrow-right-en.5498261c.svg";